import * as React from 'react';
import { JRCFileAvatar } from '../../JRCFile/JRCFileAvatar';
import { JRCFile } from '../../JRCFile/JRCFile';
import { DEFAULT_FOLDER_COLOR } from '../drive.const';

export const EntityAvatar = ({
    type,
    mimetype,
    initialFolderColor,
}: {
    type: string;
    mimetype?: string;
    initialFolderColor?: string;
}) => {
    if (type === 'folder' || type === 'group') {
        return (
            <JRCFile uri={undefined} size={2} mimetype={'folder/'} color={initialFolderColor ?? DEFAULT_FOLDER_COLOR} />
        );
    }

    return <JRCFileAvatar uri={undefined} size={40} mimetype={mimetype ?? 'application/octet-stream'} />;
};
